/* Возвращает путь для всех апишек от ApiMethod  */
const getPathFromApiMethod = (apiMethod) => `${apiMethod.getPath ? `${apiMethod.getPath()}` : ''}`;
/* Возвращает ключ из интерфейса apiMethod, по которому кешуруются данные типа
    [
        "api/v1/widget-carousel/",
        "getDomains",
        {
            "domainId": "marketplace",
            "platform": "desktop"
        }
    ]
  */
export const getQueryKeyFromApiMethod = (apiMethod, params) => [`${getPathFromApiMethod(apiMethod)}`, apiMethod.displayName, params || {}];
